module.exports = __webpack_public_path__ + "static/media/self-reqest.8a2c12d0.svg";